import { useWatcherAddressInfo } from '#/data/v1/useWatcherAddressList';
import { useMemo } from 'react';
import DistanceToNow from './DistanceToNow';

interface Props {
  symbol?: string;
  address?: string;
}
export default function NetworkAccountDateAdded({ symbol, address }: Props) {
  const addressInfo = useWatcherAddressInfo(address);
  const dateAdded = useMemo(() => addressInfo?.dateAdded, [addressInfo]);
  return dateAdded ? <DistanceToNow date={dateAdded} /> : null;
}
